import { render } from "./FormCreateKid.vue?vue&type=template&id=625838e0&scoped=true"
import script from "./FormCreateKid.vue?vue&type=script&lang=js"
export * from "./FormCreateKid.vue?vue&type=script&lang=js"

import "./FormCreateKid.vue?vue&type=style&index=0&id=625838e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625838e0"]])

export default __exports__